import React, { useState, useEffect, useCallback, useRef } from 'react';
import ModalContentBase from '../modal/hooks/modal_content_base.jsx';
import Loader from '../../components/loader.jsx';
import axios from '../axios';
import { TEXT, enterContent } from './const.js';
import SectionText from './section_text.js';
import ActionModal from './action_modal.js';
import 'babel-polyfill';
import compressImage from '../../lib/image_compressor.js';

const CANCEL_DELAY = 300; // キャンセル判定用の遅延時間

const SectionImage = ({
  index,
  content,
  userAgent,
  updateContent,
  deleteContent,
  setContents,
  setSelectedIndex,
  foreignKeyId,
  model,
  onReorder,
  isBlogEditor,
}) => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(
    content.photo_url_medium
      ? content.photo_url_medium !==
        'https://tunagate.com/images/ja2/img_noimage.gif'
        ? content.photo_url_medium
        : null
      : null
  );
  const [timeOut, setTimeOut] = useState(0); // キャンセル処理用タイムアウト
  const [isCanceled, setIsCanceled] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (userAgent !== 'pc') return;

    if (!imageSrc) {
      inputRef.current && inputRef.current.click();
      window.addEventListener('focus', dialogClosed, {
        once: true,
        passive: true,
      });

      return () => {
        window.removeEventListener('focus', dialogClosed);
      };
    }
  }, []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const dialogClosed = useCallback(() => {
    const timeoutId = setTimeout(cancelDialog, CANCEL_DELAY);
    setTimeOut(timeoutId);
  }, []);

  const cancelDialog = useCallback(() => {
    setIsCanceled(true);
    const newContent = { ...content, content_type: TEXT };
    updateContent(newContent);
    clearTimeout(timeOut);
  }, []);

  const onEdit = useCallback(() => {
    inputRef.current && inputRef.current.click();
  }, []);

  const onChange = async (e) => {
    clearTimeout(timeOut);
    setIsCanceled(false);
    closeModal();
    setLoading(true);

    if (e.target.files.length > 0) {
      let file = e.target.files[0];
      file = await compressImage(file);
      const formData = new FormData();
      formData.append('foreign_key_id', foreignKeyId);
      formData.append('file', file);
      formData.append('model', model);
      formData.append('id', content.id);
      const response = await axios.post(
        '/api/content/upload_content_image',
        formData
      );

      if (response.status !== 200) {
        alert('画像のアップロードに失敗しました。');
      }

      const newContent = response.data.find(
        (contentData) => contentData.id === content.id
      );

      if (newContent) {
        content.content_type = TEXT;
        setImageSrc(newContent.photo_url_medium);
        updateContent(newContent);
        setLoading(false);
      } else {
        content.content_type = TEXT;
        const addedContent = response.data.pop();
        setImageSrc(addedContent.photo_url_medium);
        setLoading(false);
        setContents((prev) => [...prev, addedContent]);
      }
    }
  };

  return (
    <div className="flex-grow-1">
      {isCanceled ? (
        <SectionText
          index={index}
          content={enterContent}
          userAgent={userAgent}
          updateContent={updateContent}
          isSelected={true}
          isEnterSection={true}
          setSelectedIndex={setSelectedIndex}
          deleteContent={deleteContent}
        />
      ) : loading ? (
        <Loader isActive={true} />
      ) : imageSrc ? (
        <img
          className="mt-3 mb-3 card-img-top card-img-top--list_bgwhite mb-0 w-100 cursor-pointer"
          type="image"
          style={{ maxWidth: '480px' }}
          src={imageSrc}
          onClick={() => setIsModalOpen(true)}
        />
      ) : (
        userAgent !== 'pc' && (
          <img
            className="mt-3 mb-3 card-img-top card-img-top--list_bgwhite mb-0 w-100 cursor-pointer"
            type="image"
            style={{ maxWidth: '480px' }}
            src="https://tunagate.com/images/ja2/img_noimage.gif"
            onClick={() => setIsModalOpen(true)}
          />
        )
      )}
      {/* ブログ作成だけ: 画像の「編集」ボタン（押すと編集・削除の小窓） */}
      {isBlogEditor && !isCanceled && !loading && imageSrc && (
        <button
          type="button"
          className="be-media-edit"
          aria-label="編集"
          onClick={() => setIsModalOpen(true)}
        />
      )}
      {isModalOpen && (
        <ModalContentBase
          closeModal={() => closeModal()}
          modalContent={
            <ActionModal
              closeModal={closeModal}
              onReorder={
                onReorder &&
                (() => {
                  closeModal();
                  onReorder();
                })
              }
              deleteContent={() => {
                closeModal();
                deleteContent();
              }}
              onEdit={onEdit}
            />
          }
        />
      )}
      <input
        type="file"
        ref={inputRef}
        accept="image/png, image/jpeg, image/heic, image/heif, .heic, .heif"
        onChange={onChange}
        className="d-none"
      />
    </div>
  );
};

export default SectionImage;
